"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadableStatistic = void 0;

var antd_1 = require("antd");

var Statistic_1 = __importDefault(require("antd/es/statistic/Statistic"));

var numbro_1 = __importDefault(require("numbro"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("./constants");

var LoadableStatistic = function LoadableStatistic(_a) {
  var loading = _a.loading,
      _formatter = _a.formatter,
      props = __rest(_a, ["loading", "formatter"]);

  return react_1.default.createElement(Statistic_1.default, Object.assign({
    formatter: function formatter(value) {
      if (loading) {
        return react_1.default.createElement(antd_1.Skeleton.Input, {
          active: true,
          style: {
            width: '150px'
          }
        });
      } else {
        if (typeof _formatter === 'function') {
          return _formatter(value);
        } else if (!isNaN(parseFloat(value.toString()))) {
          return (0, numbro_1.default)(value).format(constants_1.NUMBER_FORMATS.NUMBER);
        } else {
          return _formatter || value;
        }
      }
    }
  }, props));
};

exports.LoadableStatistic = LoadableStatistic;